<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-06 20:24:03
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-11-04 13:54:40
-->
<template>
	<div class="DeliveryCell flex-row">
		<div class="mr-8" v-if="avatar">
			<yx-avatar :src="avatar" :size="22"></yx-avatar>
		</div>
		<el-tooltip placement="top" :content="content" :disabled="disableToopTip">
			<div class="yx-color-text-primary">
				{{ nickname || '-' | textFormat(maxShowLength) }}
			</div>
		</el-tooltip>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {
	},
	computed: {
		avatar() {
			return this.row.socialUserDO?.avatar;
		},
		nickname() {
			return this.row.socialUserDO?.nickname;
		},
		content() {
			return this.nickname?.toString();
		},
		maxLength() {
			//通过外面配置的maxShowLength属性来确定最大显示字符串数量
			return +this.column?.maxShowLength;
		},
		maxShowLength() {
			// 当有设置maxLength的时候显示设置的最大显示数，如果没有则显示1W
			return +this.maxLength || 10000;
		},
		disableToopTip() {
			// return false 就会显示提示，存在最大的长度，并且现在的长度小于最大长度
			return !this.maxLength;
		},
	},
};
</script>
<style lang="less" scoped>
img {
	width: 22px;
	height: 22px;
	border-radius: 50%;
}
</style>
